/********************************/
/*          About vuex          */
/********************************/
// The MIT License (MIT)
//
// Copyright (c) 2015-present Evan You
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

import { mapState, mapActions } from 'vuex';
import { standbyApi } from './standby';
import { executeApi } from './execute';
import { exitApi } from './exit';
import { disposeApi } from './dispose';
import { PHASE } from './constants';
import individualDiagnose from '../../../../share/util/individualDiagnose';
import { apiErrorDefaultAction } from '../../../../share/util/api/errorAction';

export default {
  name: 'requirement150',
  data() {
    return {
      phase: PHASE.STANDBY,
      isLoading: false,
      systemId: '',
      // ダイアログフラグ
      modal_requirement_150: false,
      isSession: false
    };
  },

  props: {
    i18nWsKey: { type: String, default: '', required: true },
    workSupportId: { type: Number, default: '', required: true },
  },

  computed: {
    ...mapState({
      netAppId: state => state.netAppConnector.pairingAppId
    }),
    /**
     * ダイアログのヘッダー色
     */
    headerColor() {
      switch (this.phase) {
        case PHASE.FAILED:
          return 'danger';
        case PHASE.SUCCESS:
          return 'success';
        case PHASE.EXECUTION:
        default:
          return 'secondary';
      }
    }
  },

  methods: {
    ...mapActions('auth', ['logout', 'resetSession']),

    /** 初期化処理 */
    init() {
      this.modal_requirement_150 = true;
      // EUCキーの取得
      this.systemId = individualDiagnose.getCurrentSystemId(this);
    },

    /** 実行確認の「YES」ボタン押下 */
    async standbyProcess() {
      await standbyApi(this);
    },

    /** 実行監視初期表示 */
    async executeProcess(isSendIot) {
      await executeApi(this, isSendIot);
    },

    /** 実行確認の「NO」/ 正常終了画面の「OK」/ エラー画面の「OK」ボタン押下 */
    closeProcess() {
      this.closeWizard();
    },

    //終了処理
    async exitProcess() {
      await exitApi(this);
    },

    /**
     * 終了(session未実対応)処理
     */
    async disposeProcess() {
      await disposeApi(this);
    },

    /** エラーの表示 */
    async showError() {
      // 異常終了の場合
      this.phase = PHASE.FAILED;
      if (this.isSession) {
        await this.exitProcess();
      }
      else {
        await this.disposeProcess();
      }
    },

    /**
     * API 通信で共通バリデーションでエラーが発生した際のコールバック
     * @param {object} result バリデーション結果
     */
    validateErrorResult(result) {
      apiErrorDefaultAction(
        this,
        result,
        // ログアウト処理のコールバック
        (self) => { self; this.logout(this); },
        // セッションリセット処理のコールバック
        (self) => { self; this.resetSession(this); },
        // その他エラー発生のコールバック
        (result) => { result; this.showError(); },
      );
    },

    /** Wizardを閉じる */
    closeWizard() {
      this.$emit('close-wizard');
      this.modal_requirement_150 = false;
    },
  },

  async mounted() {
    this.init();
  },
};